import React from "react";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { Marginer } from "../components/marginer";
import { deviceSize } from "../components/responsive";
import TopSectionBackgroundImg from "../img/AODG26844.png";
import { useState } from 'react'
import { Contact } from "../Sections/contact";



import './topSection.css';

const TopSectionContainer = styled.div`
  width: auto;
  height: auto;
  background: url(${TopSectionBackgroundImg}) no-repeat;
  background-position: 0px -150px;
  background-size: cover;
  text-align: center;

  
  @media only Screen and (max-width: 40em) {
    height: 530px;

    &:hover {
      transform: none;
    }
    &:focus {
      transform: none;
    }
  }
`;

const BackgroundFilter = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(38, 70, 83, 0.9);
  display: flex;
  flex-direction: column;
`;

const TopSectionInnerContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;




const SloganText2 = styled.h3`
align-items: center;
  margin-right: 0;
  line-height: 1.4;
  color: #fff;
  font-weight: 500;
  font-size: 25px;


  @media only Screen and (max-width: 40em) {
    &:hover {
      transform: none;
    }
    &:focus {
      transform: none;
    }
  }
`;

const Title = styled.h1`
color: '#0a0b10';
font-size: calc(1rem + 0.9vw);
text-align: center;
position: relative;
&::before {
  content: "";
  height: 1px;
  width: 50%;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 0.5rem);
  /* or 100px */
  border-bottom: 2px solid var(--purple);
  }
  @media only Screen and (max-width: 40em) {
    text-align: center;

    font-size: 20px;
    &:hover {
      transform: none;
    }
    &:focus {
      transform: none;
    }
  }
`;





export function TopSection3(props) {



return (
<TopSectionContainer>
    <div className="contact-page">
    

<div id="con" className="top"  style={{textAlign:"center" ,fontSize:"25px"}} className="contact-item">
  <Title style={{textAlign:"center",color:"white"}} >

        <p >צור קשר</p>
        <p >אנחנו זמינים בשבילך בכל שאלה</p>
</Title>
        <div className="cards">

          <div className="card">
            <h3>📞 טלפון</h3>
            <p>050-6978865</p>
            <a href="tel:0506978865" className="btn">חייג עכשיו</a>
          </div>


          <div className="card">
            <h3>📧 אימייל</h3>
            <p>s.g.one2021@gmail.com</p>
            <a target="_blank" href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=s.g.one2021@gmail.com" className="btn">שלח מייל</a>
          </div>

          <div className="card">
            <h3>📍 משרדנו</h3>
            <p>  מבצע הדקל 14 פתח תקווה </p>
            <a
              href="https://www.google.com/maps?q= מבצע הדקל 14 פתח תקווה "
              target="_blank"
              className="btn"
            >
              פתח במפה
            </a>
          </div>
<div className="card">
  <h3>🕒 שעות פעילות</h3>

  <ul className="hours">
    <li>ראשון - חמישי: 08:00 - 18:30</li>
    <li>שישי: 08:00 - 13:00</li>
    <li>שבת: סגור</li>
  </ul>

  <span className="status open">● פתוח עכשיו</span>       

</div>

        </div>

      </div>
              <Contact/>

    </div>
      </TopSectionContainer>

  );
}
